<template>
  <Container class="!max-w-[1362px]">
    <div class="flex flex-col justify-center gap-9 lg:flex-row">
      <Card v-for="(card, index) in data?.cards" :key="index" :card="card" :centered="true" />
    </div>
  </Container>
</template>

<script setup lang="ts">
import Card from '../molecules/Card.vue'
import Container from '../atoms/Container.vue'
import type { ICardData } from '../../types'

export interface ICardRowBlock {
  id: string
  cards: ICardData[]
}

interface Props {
  data: ICardRowBlock
}

defineProps<Props>()
</script>
